import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { MdOutlineDarkMode, MdDarkMode } from "react-icons/md";
import { GoHomeFill } from "react-icons/go";
import { GoHome } from "react-icons/go";

export default function Navbar() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return localStorage.getItem('theme') === 'dark';
  });

  const [isVisible, setIsVisible] = useState(true);  // State to manage navbar visibility
  const [scrollPos, setScrollPos] = useState(0);     // State to track scroll position
  const [isIdle, setIsIdle] = useState(false);       // State to track user idle

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);

  const gotoTop = (e) => {
    window.scrollTo(0, 0);
  };

  // Detect scroll direction and hide navbar when scrolling down (less sensitive)
  useEffect(() => {
    let timeoutId;

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;

      // Set a threshold for when to hide the navbar (e.g., 100px)
      const scrollThreshold = 10;

      // Show navbar when scrolling up or at the top of the page
      if (currentScrollPos < scrollPos - scrollThreshold || currentScrollPos === 0) {
        setIsVisible(true);
      } else if (currentScrollPos > scrollPos + scrollThreshold) {
        setIsVisible(false);
      }

      // Update the scroll position
      setScrollPos(currentScrollPos);

      // If not at the top, start the idle timer
      if (currentScrollPos !== 0) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          setIsIdle(true);
          setIsVisible(false);
        }, 2000);
      } else {
        setIsIdle(false);
        setIsVisible(true);
      }
    };

    // Add the scroll event listener
    window.addEventListener('scroll', handleScroll);

    return () => {
      // Cleanup the event listener and timeout
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timeoutId);
    };
  }, [scrollPos]);

  return (
    <nav className={`fixed top-2 left-0 right-0 mx-auto max-w-3xl rounded-lg transition-transform duration-300 z-50 ${!isVisible ? 'transform -translate-y-full' : ''}`}>
      <div className='bg-secondary-light dark:bg-primary-dark bg-opacity-90 dark:bg-opacity-90 text-white px-4 py-3 rounded-lg shadow-lg backdrop-blur-sm'>
        <div className="flex justify-between items-center">
          {/* Logo and Home Link */}
          <div className="flex items-center">
            <Link to="/" onClick={gotoTop} className="flex items-center">
              {/* CBPF Logo - with filter for dark mode */}
              <div className="h-16 mr-3 relative">
                <img 
                  src="https://escola.cbpf.br/logos/cbpf-logo.png" 
                  alt="CBPF Logo" 
                  className={`h-full w-auto object-contain ${!isDarkMode ? 'filter invert brightness-0' : ''}`}
                />
              </div>
              
              {/* Second Logo */}
              <div className="h-16 mr-3 relative">
                <img 
                  src="https://andromeda.cbpf.br/public/litcomp-ia_logoingles.png" 
                  alt="Second Logo" 
                  className={`h-full w-auto object-contain filter invert brightness-0 ${!isDarkMode ? '' : ''}`}
                />
              </div>
              
              {/* Third Logo */}
              <div className="h-16 mr-3 relative">
                <img 
                  src="https://agnchallenge.cbpf.br/public/slsc_icon.png"
                  alt="Third Logo" 
                  className={`h-full w-auto object-contain ${!isDarkMode ? '' : ''}`}
                />
              </div>
              
              {/* Home icon moved next to logos */}
              <div className="text-xl">
                {isDarkMode ? <GoHomeFill /> : <GoHome />}
              </div>
            </Link>
          </div>

          {/* Right side controls */}
          <div className="flex items-center space-x-2">
            {/* Theme Toggle Button */}
            <button
              onClick={toggleDarkMode}
              className="p-2 rounded-full hover:bg-secondary-dark transition-colors"
              aria-label="Toggle dark mode"
            >
              {isDarkMode ? <MdOutlineDarkMode size={20} /> : <MdDarkMode size={20} />}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
